<template>
    <dropdown-menu
        style="height: 25px;"
        v-bind:show-caret-icon="false">
        <span class="text-right f-s-2" slot="trigger">&bull;&bull;&bull;</span>
        <a v-on:click.prevent="triggerAction('edit')" href="#edit-popup" class="c-primary p-t-2 p-b-2 p-l-4 p-r-4 f-s-3 block h-anim h-bg-accent--light">{{ trans('Edit ') }}</a>
        <a v-bind:inert="previewLink ? false : true" v-bind:href="previewLink" class="row row-collapse row-middle c-primary p-t-2 p-b-2 p-l-4 p-r-4 f-s-3 h-anim h-bg-accent--light" target="website">
            <div class="column">
                <span class="c-primary f-size-small">{{ trans('Preview') }}</span>
            </div>
            <div class="text-right">
                <span class="i-container i-filled-dark">
                    <!-- /icons/out-link-small.svg -->
                    <svg class="icon i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M18.125 5H12v1.75h4.025l-5.513 5.513 1.225 1.224 5.513-5.512V12H19V5.875C19 5.35 18.65 5 18.125 5z"/><path d="M17.25 19H5.875C5.35 19 5 18.65 5 18.125V6.75c0-.525.35-.875.875-.875h3.5v1.75H6.75v9.625h9.625v-2.625h1.75v3.5c0 .525-.35.875-.875.875z"/></g></svg>
                </span>
            </div>
        </a>
        <div class="br-top"></div>
        <a v-on:click.prevent="triggerAction('delete')" href="#delete-popup" class="c-error p-t-2 p-b-2 p-l-4 p-r-4 block f-s-3 h-anim h-bg-accent--light">{{ trans('Delete ') }}</a>
    </dropdown-menu>
</template>
<script>
import DropdownMenu from '../DropdownMenu.vue';

export default {
    components: {
        DropdownMenu
    },
    props: {
        index: {
            type: Number,
            required: true
        },
        previewLink: {
            type: String,
            default: null
        }
    },
    methods: {
        triggerAction(action) {
            this.$emit('trigger', action, this.index);
        },
    }
}
</script>